import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://baohu.idea888.com/baohuXcx',
});

export default instance;
